/*
 * © 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/KlondikeLogic/KlondikeAuthority',[
        'absolute/debug',
        'Arkadium/GameEngine/Core/EngineManagers',
        'SolitaireShared/CardLogic/IGameAuthority',
        'SolitaireShared/CardLogic/TipEventArgs',
        'SolitaireShared/CardLogic/Supply',
        'SolitaireShared/CardLogic/Card',
        'SolitaireShared/CardLogic/Pile',
        'SolitaireShared/CardLogic/CardValue',
        'SolitaireShared/CardLogic/CardColor',
        'SolitaireShared/CardLogic/CardSuit',
        'SolitaireShared/CardLogic/CardAction',
        'SolitaireShared/CardLogic/CardOp',
        'SolitaireShared/CardLogic/MoveState',
        'SolitaireShared/CardLogic/DealData'
    ],
    function (Debug, EngineManagers, IGameAuthority, TipEventArgs, Supply, Card, Pile, CardValue, CardColor, CardSuit, CardAction, CardOp, MoveState, DealData) {

    var KlondikeAuthority = function () {
        this.initKlondikeAuthority();
    };

        KlondikeAuthority.constructor = KlondikeAuthority;
        KlondikeAuthority.prototype = Object.create(IGameAuthority.prototype);

    /*
    public event OnTipEventHandler OnTip;
    public event OnBonusEffectEventHandler OnBonusEffect;
    public event OnAuthorityDealEventHanlder OnDealEvent;
    */

    KlondikeAuthority.STANDARD = "STANDARD";
    KlondikeAuthority.LAS_VEGAS = "LASVEGAS";
    KlondikeAuthority.LAS_VEGAS_CUMULATIVE = "LASVEGASCUMULATIVE";

    KlondikeAuthority.TAG_PASSTHROUGHDECK = 0x1;

    


    KlondikeAuthority.prototype.initKlondikeAuthority = function () {
        this.CardSupply = new Supply("Klondike");

        this.CardSupply.Authority = this;

        this.WinSetAction = null;
        this.IceCastleCheck = [];
        this.CompletedIceCastle = false;
        this.PassesThroughDeck = 0;
        this.MaxCardsUsedFromWaste = 0;
        this.CurrentCardsUsedFromWaste = 0;
        this.lastStockCount = 0;//this.CardSupply.GetPile("Stock").Count;
        this.availableMovesSinceLastPassThroughDeck = true;
        this.lastHint = null;
        this.IsChallenge = false;        
        this.MAX_DEALS = 0;
        this.DealScript = KlondikeAuthority.DefaultDealScript;
    };


    KlondikeAuthority.prototype.Setup = function () {
        this.CardSupply.AddPile("Stock", "Stock");
        this.CardSupply.AddPile("Waste", "Waste");

        this.CardSupply.AddPile("Foundation0", "Foundation");
        this.CardSupply.AddPile("Foundation1", "Foundation");
        this.CardSupply.AddPile("Foundation2", "Foundation");
        this.CardSupply.AddPile("Foundation3", "Foundation");

        this.CardSupply.AddPile("FaceDown0", "FaceDown");
        this.CardSupply.AddPile("Tableau0", "Tableau");
        this.CardSupply.AddPile("FaceDown1", "FaceDown");
        this.CardSupply.AddPile("Tableau1", "Tableau");
        this.CardSupply.AddPile("FaceDown2", "FaceDown");
        this.CardSupply.AddPile("Tableau2", "Tableau");
        this.CardSupply.AddPile("FaceDown3", "FaceDown");
        this.CardSupply.AddPile("Tableau3", "Tableau");
        this.CardSupply.AddPile("FaceDown4", "FaceDown");
        this.CardSupply.AddPile("Tableau4", "Tableau");
        this.CardSupply.AddPile("FaceDown5", "FaceDown");
        this.CardSupply.AddPile("Tableau5", "Tableau");
        this.CardSupply.AddPile("FaceDown6", "FaceDown");
        this.CardSupply.AddPile("Tableau6", "Tableau");

        this.CardSupply.CreateCards(1, 4, 0);
    };

    KlondikeAuthority.prototype.Reset = function () {
        this.IceCastleCheck = [];
        this.CompletedIceCastle = false;
        this.PassesThroughDeck = 0;
        this.MaxCardsUsedFromWaste = 0;
        this.CurrentCardsUsedFromWaste = 0;
        if (this.CardSupply) {
            this.lastStockCount = this.CardSupply.GetPile("Stock").Count;
        }
        this.availableMovesSinceLastPassThroughDeck = true;
    };

    KlondikeAuthority.prototype.BoardsCompleted = function () {
        return -1;
    };

    KlondikeAuthority.prototype.NumDealsLeft = function () {
        return 0;
    };

    KlondikeAuthority.prototype.Deal = function () {
        this.CardSupply.PrepareGame();

        if (this.CardSupply.CardAnimator != null) {
            this.CardSupply.CardAnimator.BeginShuffleAnimation();
        }

        this.CardSupply.DeckSeed = this.CardSupply.RootPile.Shuffle(this.CardSupply.DeckSeed);

        this.CardSupply.OnShuffleCards();

        CardAction.RunActions(this.CardSupply, this.DealScript);
        //EngineManagers.Sounds.PlaySound("Deal_Klondike");

        this.CardSupply.StartGame();

        // Set up variables for "no moves left" detection.
        this.PassesThroughDeck = 0;
        this.lastStockCount = this.CardSupply.GetPile("Stock").Count;
        this.availableMovesSinceLastPassThroughDeck = true;

        return true;
    };

    KlondikeAuthority.prototype.Tick = function (playedTime) {

    };

    KlondikeAuthority.prototype.FoundationCanTakeCard = function (foundation, card, triggerTips) {
        triggerTips = !!triggerTips;

        if (foundation == null || card == null) {
            return false;
        }

        if (card.Value == CardValue.Values.Joker) {
            return false;
        }

        if (foundation.Empty)
        {
            if (card.Value == CardValue.Values.Ace)
            {
                return true;
            }
            else
            {
                if (triggerTips && this.OnTip != null) {
                    this.OnTip(this, new TipEventArgs("Tips_FoundationPile"));
                }

                return false;
            }
        }

        if (!foundation.Empty &&
            card.Suit == foundation.Top.Suit &&
            card.ValueNum == foundation.Top.ValueNum + 1 &&
            card.Suit != CardSuit.None)
        {
            return true;
        }
        else
        {
            if (triggerTips && this.OnTip != null) {
                this.OnTip(this, new TipEventArgs("Tips_FoundationPile"));
            }

            return false;
        }
    };

    KlondikeAuthority.prototype.TableauCanTakeCard = function (tableau, card, triggerTips) {
        triggerTips = !!triggerTips;

        if (tableau == null || card == null) {
            return false;
        }

        if (card.Value == CardValue.Values.Joker) {
            return false;
        }

        if (tableau.Empty)
        {
            if (card.Value == CardValue.Values.King)
            {
                return true;
            }
            else
            {
                if (triggerTips && this.OnTip != null)
                    this.OnTip(this, new TipEventArgs("Tips_Klondike_EmptyPile"));

                return false;
            }
        }

        if (card.Color == tableau.Top.Color)
        {
            if (triggerTips && this.OnTip != null)
                this.OnTip(this, new TipEventArgs("Tips_SameColor"));

            return false;
        }

        if (card.ValueNum != tableau.Top.ValueNum - 1)
        {
            if (triggerTips && this.OnTip != null)
                this.OnTip(this, new TipEventArgs("Tips_OutOfOrder"));

            return false;
        }

        if (card.Color != CardColor.None && tableau.Top.Color != CardColor.None)
        {
            return true;
        }

        return false;

    };

    KlondikeAuthority.prototype.FaceDownForTableau = function (tableau) {
        if (tableau == null)
            return null;

        if (tableau.Name == "Tableau0") return tableau.Supply.GetPile("FaceDown0");
        if (tableau.Name == "Tableau1") return tableau.Supply.GetPile("FaceDown1");
        if (tableau.Name == "Tableau2") return tableau.Supply.GetPile("FaceDown2");
        if (tableau.Name == "Tableau3") return tableau.Supply.GetPile("FaceDown3");
        if (tableau.Name == "Tableau4") return tableau.Supply.GetPile("FaceDown4");
        if (tableau.Name == "Tableau5") return tableau.Supply.GetPile("FaceDown5");
        if (tableau.Name == "Tableau6") return tableau.Supply.GetPile("FaceDown6");

        return null;

    };

    KlondikeAuthority.prototype.IsActionAllowed = function (action, triggerTips)
    {
        if (action == null || action.Ops == null || action.Ops.length == 0)
            return false;

        var op = action.Ops[0];

        if (action.Ops.length == 1 && op.Opcode == CardOp.Op.Undo)
        {
            // always allow an undo by itself
            return true;
        }

        if (action.IsNoop())
        {
            // always allow a no-op action
            return true;
        }

        if (action.Ops.length == 1 && op.Opcode == CardOp.Op.Game)
        {
            // always allow the game to be started
            return true;
        }

        if (op && op.Opcode == CardOp.Op.Move)
        {
            var SourcePile = op.GetPile(CardOp.eMoveParams.SourcePile);
            var DestPile = op.GetPile(CardOp.eMoveParams.DestPile);
            var NumCards = op.GetNumber(CardOp.eMoveParams.NumCards);

            if (action.Ops.length == 1)
            {
                // This is the only operation in our action

                if (SourcePile == null || DestPile == null)
                {
                    // couldn't get a pile ID for some reason, oops
                    return false;
                }
                else if (SourcePile.Type == "Tableau" && DestPile.Type == "Tableau")
                {
                    var FaceDown = this.FaceDownForTableau(SourcePile);
                    if (NumCards > 0 &&
                        SourcePile.Count >= NumCards &&
                        FaceDown != null &&
                        (FaceDown.Empty || SourcePile.Count > NumCards))
                    {
                        if (this.TableauCanTakeCard(DestPile, SourcePile.NthFromTop(NumCards), triggerTips))
                        {
                            return true;
                        }
                    }
                }
                else if (SourcePile.Type == "Tableau" && DestPile.Type == "Foundation")
                {
                    var FaceDown = this.FaceDownForTableau(SourcePile);
                    if (NumCards == 1 &&
                        !SourcePile.Empty &&
                        FaceDown != null &&
                        (FaceDown.Empty || SourcePile.Count > 1) &&
                        this.FoundationCanTakeCard(DestPile, SourcePile.Top, triggerTips))
                        return true;
                }
                else if (SourcePile.Type == "Foundation" && DestPile.Type == "Tableau")
                {
                    if (NumCards == 1 &&
                        !SourcePile.Empty &&
                        this.TableauCanTakeCard(DestPile, SourcePile.Top, triggerTips))
                        return true;
                }
                else if (SourcePile.Type == "Foundation" && DestPile.Type == "Foundation")
                {
                    // weird case: let us place a lone ace onto another empty foundation pile. why? why not.
                    if (NumCards == 1 &&
                        SourcePile.Top.Value == CardValue.Values.Ace &&
                        DestPile.Empty)
                        return true;
                }
                else if (SourcePile.Type == "Stock" && DestPile.Type == "Waste")
                {
                    //if (CurrentMoveState() == MoveState.NoMovesLeft)
                    //    return false;

                    var Option_NumCardsPerDraw = parseInt(this.CardSupply.GetOption("Draw"));
                    if (NumCards < 0 &&
                        (
                            (-NumCards == Option_NumCardsPerDraw && SourcePile.Count >= -NumCards) ||
                            (-NumCards < Option_NumCardsPerDraw && SourcePile.Count == -NumCards)
                            ) &&
                        !SourcePile.Empty)
                        return true;
                }
                else if (SourcePile.Type == "Waste" && DestPile.Type == "Stock")
                {
                    //if (CurrentMoveState() == MoveState.NoMovesLeft)
                    //    return false;

                    var dealsLeft = !this.IsNumDecksLimited() || this.PassesThroughDeck < 2;

                    if (NumCards < 0 &&
                        DestPile.Empty &&
                        SourcePile.Count == -NumCards &&
                        dealsLeft)
                    {
                        return true;
                    }
                }
                else if (SourcePile.Type == "Waste" && DestPile.Type == "Tableau")
                {
                    if (NumCards == 1 &&
                        !SourcePile.Empty &&
                        this.TableauCanTakeCard(DestPile, SourcePile.Top, triggerTips))
                        return true;
                }
                else if (SourcePile.Type == "Waste" && DestPile.Type == "Foundation")
                {
                    if (NumCards == 1 &&
                        !SourcePile.Empty &&
                        this.FoundationCanTakeCard(DestPile, SourcePile.Top, triggerTips))
                        return true;
                }
            }
            else if (action.Ops.length == 2)
            {
                var opB = action.Ops[1];

                if (opB.Opcode == CardOp.Op.Move)
                {

                    var SourcePileB = opB.GetPile(CardOp.eMoveParams.SourcePile);
                    var DestPileB = opB.GetPile(CardOp.eMoveParams.DestPile);
                    var NumCardsB = opB.GetNumber(CardOp.eMoveParams.NumCards);

                    if (SourcePile == null || DestPile == null)
                    {
                        // couldn't get a pile ID for some reason, oops
                        return false;
                    }
                    else if (SourcePile.Type == "Tableau" && DestPile.Type == "Tableau" &&
                        SourcePileB.Type == "FaceDown" && DestPileB == SourcePile)
                    {
                        var FaceDown = this.FaceDownForTableau(SourcePile);

                        if (NumCards > 0 &&
                            NumCardsB == 1 &&
                            FaceDown != null &&
                            FaceDown == SourcePileB &&
                            !FaceDown.Empty &&
                            SourcePile.Count == NumCards &&
                            this.TableauCanTakeCard(DestPile, SourcePile.NthFromTop(NumCards), triggerTips))
                            return true;
                    }
                    else if (SourcePile.Type == "Tableau" && DestPile.Type == "Foundation" &&
                        SourcePileB.Type == "FaceDown" && DestPileB == SourcePile)
                    {
                        var FaceDown = this.FaceDownForTableau(SourcePile);

                        if (NumCards == 1 &&
                            NumCardsB == 1 &&
                            FaceDown != null &&
                            FaceDown == SourcePileB &&
                            !FaceDown.Empty &&
                            SourcePile.Count == 1 &&
                            this.FoundationCanTakeCard(DestPile, SourcePile.Top, triggerTips))
                            return true;
                    }
                }
            }
        }
        return false;
    };

    KlondikeAuthority.prototype.CanAutoSolve = function ()
    {
        if (this.CardSupply.GetPile("FaceDown0").Empty && this.CardSupply.GetPile("FaceDown1").Empty
            && this.CardSupply.GetPile("FaceDown2").Empty && this.CardSupply.GetPile("FaceDown3").Empty
            && this.CardSupply.GetPile("FaceDown4").Empty && this.CardSupply.GetPile("FaceDown5").Empty
            && this.CardSupply.GetPile("FaceDown6").Empty && this.CardSupply.GetPile("Stock").Empty
            && this.CardSupply.GetPile("Waste").Empty && this.CardSupply.GetPile("Foundation0").Count > 0)
        {
            return true;
        }

        return false;
    };

    KlondikeAuthority.prototype.CanKeyboardFocusCard = function (card)
    {
        return this.CanPickupCard(card);
    };

    KlondikeAuthority.prototype.CanPickupCard = function (card)
    {
        if (this.CardSupply.WaitingForBlockingAnimation)
            return false;

        if (this.CardSupply.WaitingForAnimation)
            return false;

        if (card.Pile.Type == "Tableau")
            return true;

        if (card.Pile.Type == "Waste")
        {
            if (card.Pile.GetCardPosFromEnd(card) == 1)
                return true;
        }

        if (card.Pile.Type == "Foundation" &&
            card.Pile.GetCardPosFromEnd(card) == 1)
        {
            return true;
        }

        return false;
    };

    KlondikeAuthority.prototype.CanAcceptCards = function (pile)
    {
        if (pile.Type == "Foundation" || pile.Type == "Tableau")
            return true;
        else
            return false;
    };

    KlondikeAuthority.prototype.GetScoreForAction = function (action)
    {
        if (action == null || action.Ops == null || action.Ops.length == 0)
            return 0;

        var op = action.Ops[0];

        if (action.Ops.length == 1 && op.Opcode == CardOp.Op.Undo)
        {
            return 0; // the undone action itself will negate its own score
        }

        var score = 0;

        if (op.Opcode == CardOp.Op.Move)
        {
            var SourcePile = op.GetPile(CardOp.eMoveParams.SourcePile);
            var DestPile = op.GetPile(CardOp.eMoveParams.DestPile);
            var NumCards = op.GetNumber(CardOp.eMoveParams.NumCards);

            var isStandardScoring = this.CardSupply.GetOption("Scoring") == KlondikeAuthority.STANDARD;

            if (SourcePile == null || DestPile == null)
            {
                // couldn't get a pile ID for some reason, oops
                return 0;
            }
            else if (SourcePile.Type == "Waste" && DestPile.Type == "Tableau")
            {
                if (isStandardScoring)
                    score = 5;
            }
            else if (SourcePile.Type == "Waste" && DestPile.Type == "Foundation")
            {
                if (isStandardScoring)
                    score = 10;
                else
                    score = 5;
            }
            else if (SourcePile.Type == "Tableau" && DestPile.Type == "Foundation")
            {
                if (isStandardScoring)
                {
                    score = 10;

                    // check if there is a second action that turns over a tableau card for +5 bonus
                    if (action.Ops.length == 2)
                    {
                        // the move will be verified, so this must be a facedown to faceup card move
                        score += 5;
                    }
                }
                else
                    score = 5;
            }
            else if (SourcePile.Type == "Tableau" && DestPile.Type == "Tableau")
            {
                if (isStandardScoring)
                {
                    score = 0;

                    // check if there is a second action that turns over a tableau card for +5 bonus
                    if (action.Ops.length == 2)
                    {
                        // the move will be verified, so this must be a facedown to faceup card move
                        score += 5;
                    }
                }
            }
            else if (SourcePile.Type == "Foundation" && DestPile.Type == "Tableau")
            {
                if (isStandardScoring)
                    score = -10;
                else
                    score = -5;
            }
            else if (SourcePile.Type == "Waste" && SourcePile.Count == 0)
            {
                action.Tag |= KlondikeAuthority.TAG_PASSTHROUGHDECK;
            }
        }

        return score;
    };

    KlondikeAuthority.prototype.GetScoreForTimer = function(currTimer, prevTimer)
    {
        var useTimer = this.CardSupply.GetOption("KlondikeTimer") == "TRUE";

        if (useTimer && this.CardSupply.GetOption("Scoring") == KlondikeAuthority.STANDARD)
        {
            return Math.floor((700000 / Math.max(1, this.CardSupply.CurrentTime))); // Avoid divide-by-zero.
        }
        return 0;
    };


    KlondikeAuthority.prototype.GetBonusScore = function (finalTimer)
    {
        var useTimer = this.CardSupply.GetOption("KlondikeTimer") == "TRUE";

        if (useTimer && finalTimer > 30)
        {
            return Math.floor(700000 / Math.max(1, this.CardSupply.TimePlayed));
        }

        return 0;
    };

    /// <summary>
    /// Get the maximum allowed score in this game. Usually MaxInt.
    /// </summary>
    /// <returns></returns>
    KlondikeAuthority.prototype.GetMaxScore = function ()
    {
        return Number.MAX_VALUE; // TODO check this
    };

    /// <summary>
    /// Get the minimum allowed score in this game. Either MinInt or 0, depending on if negative score is allowed.
    /// </summary>
    /// <returns></returns>
    KlondikeAuthority.prototype.GetMinScore = function ()
    {
        var minScore = 0;

        switch (this.CardSupply.GetOption("Scoring"))
        {
            case KlondikeAuthority.STANDARD:
                minScore = 0;
                break;

            case KlondikeAuthority.LAS_VEGAS:
                minScore = -52;
                break;

            case KlondikeAuthority.LAS_VEGAS_CUMULATIVE:
                minScore = -(Number.MAX_VALUE - 1);
                break;
        }

        return minScore;
    };

    KlondikeAuthority.prototype.GetStartingScore = function ()
    {
        var startingScore = 0;

        switch (this.CardSupply.GetOption("Scoring"))
        {
            case KlondikeAuthority.STANDARD:
                /*bool useTimer = true;
                 bool.TryParse(CardSupply.GetOption("KlondikeTimer"), out useTimer);

                 if (useTimer)
                 return 700000;*/
                return 0;

            case KlondikeAuthority.LAS_VEGAS:
                startingScore = -52;
                break;

            case KlondikeAuthority.LAS_VEGAS_CUMULATIVE:
                startingScore = this.CardSupply.CumulativeScore;
                break;
        }

        return startingScore;
    };

    KlondikeAuthority.prototype.GetStartingTime = function ()
    {
        return 0;
    };

    KlondikeAuthority.prototype.IsGameWon = function ()
    {
        if (this.CardSupply.WaitingForAnimation)
        {
            // We don't win unless the card animation is finished.
            return false;
        }

        return this.CheckWin();
    };

    KlondikeAuthority.prototype.CheckWin = function ()
    {
        if (this.GetCompletedStacks() == 4)
            return true;

        return false;
    };

    KlondikeAuthority.prototype.GetCompletedStacks = function ()
    {
        var completedStacks = 0;

        if (this.CardSupply.GetPile("Foundation0").Count == 13)
            completedStacks++;
        if (this.CardSupply.GetPile("Foundation1").Count == 13)
            completedStacks++;
        if (this.CardSupply.GetPile("Foundation2").Count == 13)
            completedStacks++;
        if (this.CardSupply.GetPile("Foundation3").Count == 13)
            completedStacks++;

        return completedStacks;
    };

    KlondikeAuthority.prototype.GetHint = function (cycle)
    {
        cycle = !!cycle;
        return this.GetHintInternal(cycle);
    };

    KlondikeAuthority.prototype.GetHintInternal = function (cycle)
    {
        cycle = !!cycle;
        var i, j, args, hint;

        var numTableaus = 7;
        var numFoundations = 4;

        var hints = [];

        var source, destination;

        // Tableau-a-foundation first.
        for (i = 0; i < numTableaus; i++)
        {
            source = this.CardSupply.GetPile("Tableau" + i);
            if (source.Empty)
                continue;

            for (j = 0; j < numFoundations; j++)
            {
                destination = this.CardSupply.GetPile("Foundation" + j);
                if (this.FoundationCanTakeCard(destination, source.Top))
                {
                    hint = new CardOp(this.CardSupply);
                    args = [ "MOVE", source.Name, destination.Name, "1" ];
                    hint.Parse(args, 0);
                    hints.push(hint);
                }
            }
        }

        if (!cycle && hints.length > 0)
            return hints[0];

        // Waste-a-foundation second.
        source = this.CardSupply.GetPile("Waste");
        for (i = 0; i < numFoundations; i++)
        {
            destination = this.CardSupply.GetPile("Foundation" + i);
            if (this.FoundationCanTakeCard(destination, source.Top))
            {
                hint = new CardOp(this.CardSupply);
                args = [ "MOVE", source.Name, destination.Name, "1" ];
                hint.Parse(args, 0);
                hints.push(hint);
            }
        }

        if (!cycle && hints.length > 0)
            return hints[0];

        // Tableau-a-tableau third.
        for (i = 0; i < numTableaus; i++)
        {
            source = this.CardSupply.GetPile("Tableau" + i);
            if (source.Empty ||
                source.Bottom.Value == CardValue.Values.King && this.CardSupply.GetPile("FaceDown" + i).Empty) // Don't bother moving a stack of Kings around empty tableaus.
            {
                continue;
            }

            for (j = 0; j < numTableaus; j++)
            {
                if (i == j)
                    continue;

                destination = this.CardSupply.GetPile("Tableau" + j);
                if (this.TableauCanTakeCard(destination, source.Bottom))
                {
                    hint = new CardOp(this.CardSupply);
                    args = [ "MOVE", source.Name, destination.Name, source.Count.toString() ];
                    hint.Parse(args, 0);
                    hints.push(hint);
                }
            }
        }

        if (!cycle && hints.length > 0)
            return hints[0];

        // Waste-a-tableau fourth.
        source = this.CardSupply.GetPile("Waste");
        for (i = 0; i < numTableaus; i++)
        {
            destination = this.CardSupply.GetPile("Tableau" + i);
            if (this.TableauCanTakeCard(destination, source.Top))
            {
                hint = new CardOp(this.CardSupply);
                args = [ "MOVE", source.Name, destination.Name, "1" ];
                hint.Parse(args, 0);
                hints.push(hint);
            }
        }

        if (!cycle && hints.length > 0)
            return hints[0];

        // Stock-a-waste and waste-a-stock preferred last.
        if (this.CardSupply.GetPile("Stock").Count > 0)
        {
            hint = new CardOp(this.CardSupply);
            args = [ "MOVE", "Stock", "Stock", "1" ];
            hint.Parse(args, 0);
            hints.push(hint);
        }
        else if (this.CardSupply.GetPile("Waste").Count > 0)
        {
            if (!this.IsNumDecksLimited() || this.PassesThroughDeck < 2)
            {
                hint = new CardOp(this.CardSupply);
                args = [ "MOVE", "Stock", "Stock", "1" ];
                hint.Parse(args, 0);
                hints.push(hint);
            }
        }

        if (!cycle && hints.length > 0)
            return hints[0];

        // Check if we can reveal the next card to go to a foundation
        for (i = 0; i < numFoundations; i++)
        {
            var foundation = this.CardSupply.GetPile("Foundation" + i);

            if (foundation != null && !foundation.Empty)
            {
                var foundCard = false;
                var valueToFind = foundation.Top.Value + 1;
                var suitToFind = foundation.Top.Suit;

                for (var tableauNum = 0; tableauNum < numTableaus && !foundCard; tableauNum++)
                {
                    var tableau = this.CardSupply.GetPile("Tableau" + tableauNum);

                    for (var pos = 1; pos <= tableau.Count && !foundCard; pos++)
                    {
                        var nthFromTop = tableau.NthFromTop(pos);
                        if (nthFromTop.Value == valueToFind && nthFromTop.Suit == suitToFind)
                        {
                            var nextCardDown = tableau.NthFromTop(pos - 1);

                            foundCard = true;
                            for (var tabSearchingNum = 0; tabSearchingNum < numTableaus; tabSearchingNum++)
                            {
                                var tableauSearching = this.CardSupply.GetPile("Tableau" + tabSearchingNum);

                                if (this.TableauCanTakeCard(tableauSearching, nextCardDown))
                                {
                                    hint = new CardOp(this.CardSupply);
                                    args = [ "MOVE", tableau.Name, tableauSearching.Name, (pos-1).toString() ];
                                    hint.Parse(args, 0);
                                    hints.push(hint);
                                }
                            }
                        }
                    }
                }
            }
        }

        if (!cycle && hints.length > 0)
            return hints[0];

        if (hints.length > 0)
        {
            if (!cycle)
            {
                return hints[0];
            }
            else if (cycle)
            {
                if (this.LastHint != null)
                {
                    // Find the position of the last hint in the hint list (if possible).
                    var index;
                    for (index = 0; index < hints.length; index++)
                    {
                        if (hints[index].Equals(this.LastHint))
                            break;
                    }

                    if (index >= hints.length - 1)
                    {
                        var hint = hints[0];
                        this.LastHint = hint;
                        return hint;
                    }
                    else
                    {
                        hint = hints[index + 1];
                        this.LastHint = hint;
                        return hint;
                    }
                }
                else
                {
                    hint = hints[0];
                    this.LastHint = hint;
                    return hint;
                }
            }
        }

        return new CardOp(this.CardSupply);
    };

    KlondikeAuthority.prototype.GetCardHint = function(card) {
        var i, dest, tableauCount = 7, foundationCount = 4,
            src = card.Pile, hint = new CardOp(this.CardSupply),
            cardPos = src.GetCardPosFromEnd(card),
            cardPosStr = cardPos.toString(),
            srcPos = parseInt(src.Name[src.Name.length - 1]);
        if (src.Type === "Tableau") {
            if (cardPos === 1) {
                // Tableau to Foundation
                for (i = 0; i < foundationCount; i++) {
                    dest = this.CardSupply.GetPile("Foundation" + i);
                    if (!this.FoundationCanTakeCard(dest, card, false)) continue;
                    hint.Parse(["MOVE", src.Name, dest.Name, cardPosStr], 0);
                    return hint;
                }
            }
            // Don't bother moving a stack of Kings around empty tableaus
            if (src.Bottom === card && card.Value === CardValue.Values.King &&
                this.CardSupply.GetPile("FaceDown" + srcPos).Empty) return;
            // Tableau to Tableau: from src pile's next neighbor to the end
            for (i = (srcPos + 1); i < tableauCount; i++) {
                dest = this.CardSupply.GetPile("Tableau" + i);
                if (!this.TableauCanTakeCard(dest, card, false)) continue;
                hint.Parse(["MOVE", src.Name, dest.Name, cardPosStr], 0);
                return hint;
            }
            // Tableau to Tableau: from the start to the src pile's previous neighbor
            for (i = 0; i < srcPos; i++) {
                dest = this.CardSupply.GetPile("Tableau" + i);
                if (!this.TableauCanTakeCard(dest, card, false)) continue;
                hint.Parse(["MOVE", src.Name, dest.Name, cardPosStr], 0);
                return hint;
            }
        } else if (src.Type === "Waste") {
            // Waste to Foundation
            for (i = 0; i < foundationCount; i++) {
                dest = this.CardSupply.GetPile("Foundation" + i);
                if (!this.FoundationCanTakeCard(dest, card)) continue;
                hint.Parse(["MOVE", src.Name, dest.Name, cardPosStr], 0);
                return hint;
            }
            // Waste to Tableau
            for (i = 0; i < tableauCount; i++) {
                dest = this.CardSupply.GetPile("Tableau" + i);
                if (!this.TableauCanTakeCard(dest, card, false)) continue;
                hint.Parse(["MOVE", src.Name, dest.Name, cardPosStr], 0);
                return hint;
            }
        } else if (src.Type === "Foundation" ) {
            // Foundation to Tableau
            for (i = 0; i < tableauCount; i++) {
                dest = this.CardSupply.GetPile("Tableau" + i);
                if (!this.TableauCanTakeCard(dest, card, false)) continue;
                hint.Parse(["MOVE", src.Name, dest.Name, cardPosStr], 0);
                return hint;
            }
        }
    };

    KlondikeAuthority.prototype.GetAutomaticMove = function ()
    {
        // Automatic moves not supported.
        return null;
    };

    KlondikeAuthority.prototype.CurrentMoveState = function ()
    {
        var hint = this.GetHintInternal(true);

        var currentStockCount = this.CardSupply.GetPile("Stock").Count;

        // If this method is being called after the stock has changed (since the last invocation).
        if (this.lastStockCount != currentStockCount && this.CardSupply.GetPile("Waste").Count > 0)
        {
            // If we just passed through the deck.
            if (this.lastStockCount > 0 && currentStockCount == 0)
            {
                // If this isn't the first pass through the deck AND
                // there haven't been any valid moves since the last pass.
                if (this.PassesThroughDeck > 0 && !this.availableMovesSinceLastPassThroughDeck)
                {
                    return MoveState.NoMovesLeft;
                }

                this.availableMovesSinceLastPassThroughDeck = false;
                //PassesThroughDeck++;
            }

        }
        this.lastStockCount = currentStockCount;

        // Mark the flag to true if we see a move (other than stock-to-waste
        // or vice versa) since the last pass through the deck.
        if (hint.Opcode != CardOp.Op.Noop &&
            hint.GetPile(CardOp.eMoveParams.SourcePile).Name != "Stock" &&
            hint.GetPile(CardOp.eMoveParams.DestPile).Name != "Stock")
        {
            this.availableMovesSinceLastPassThroughDeck = true;
        }

        if (this.CardSupply.WaitingForAnimation || this.IsGameWon())
            return MoveState.CanMove;

        if (hint.Opcode == CardOp.Op.Noop && !this.CardSupply.WaitingForAnimation)
            return MoveState.NoMovesLeft;
        else
            return MoveState.CanMove;
    };

    KlondikeAuthority.prototype.ResetNoMoreMovesState = function ()
    {
        if (!this.IsNumDecksLimited())
        {
            this.PassesThroughDeck = 0;
        }
    };

    KlondikeAuthority.prototype.TriggerTip = function (e)
    {
        if (this.OnTip != null)
            this.OnTip(this, e);
    };

    KlondikeAuthority.prototype.OnRunAction = function (action, undo, triggerTips)
    {
        var op = action.Ops[0];
        if (op.Opcode != CardOp.Op.Move)
        {
            return;
        }
        var srcPile = op.GetPile(CardOp.eMoveParams.SourcePile);
        var dstPile = op.GetPile(CardOp.eMoveParams.DestPile);
        if (srcPile.Type == "Waste" && (dstPile.Type=="Foundation" || dstPile.Type=="Tableau"))
        {
            this.CurrentCardsUsedFromWaste = Math.max(0,undo ? this.CurrentCardsUsedFromWaste - 1 : this.CurrentCardsUsedFromWaste + 1);
        }
        else
        {
            this.CurrentCardsUsedFromWaste = 0;
        }
        this.MaxCardsUsedFromWaste = Math.max(this.CurrentCardsUsedFromWaste, this.MaxCardsUsedFromWaste);

        if (srcPile.Type != "Foundation" && dstPile.Type == "Foundation" && !undo)
        {
            if (dstPile.Top != null)
            {
                var cardValue = dstPile.Top.Value;
                if (this.IceCastleCheck.indexOf(cardValue) != -1)
                {
                    this.IceCastleCheck = [];
                }
                else if (cardValue == CardValue.Values.King || cardValue == CardValue.Values.Queen || cardValue == CardValue.Values.Jack)
                {
                    this.IceCastleCheck.push(cardValue);
                    if (this.IceCastleCheck.length == 3)
                    {
                        this.CompletedIceCastle = true;
                    }
                }
                else
                {
                    this.IceCastleCheck = [];
                }
            }
        }
        else
        {
            this.IceCastleCheck = [];
        }
    };

    KlondikeAuthority.prototype.OnRunSpecialAction = function (tag, undo)
    {
        if ((tag & KlondikeAuthority.TAG_PASSTHROUGHDECK) != 0)
        {
            if (!undo)
                this.PassesThroughDeck++;
            else if (this.IsNumDecksLimited()) {
                this.PassesThroughDeck--;
                this.availableMovesSinceLastPassThroughDeck = true;
            }
        }
    };

    KlondikeAuthority.prototype.OnGameOver = function (fullActionList, collapsedActionList)
    {
        var bonus = this.GetBonusScore(this.CardSupply.TimePlayed);
        this.CardSupply.Score += bonus;
        this.CardSupply.CumulativeScore = this.CardSupply.Score;
    };

    KlondikeAuthority.prototype.IsNumDecksLimited = function ()
    {
        return (this.CardSupply.GetOption("Scoring") != KlondikeAuthority.STANDARD);
    };

    KlondikeAuthority.prototype.GenerateDealData = function ()
    {
        var i, res;
        var cardIndex = 0;
        var script = "";
        var deck = [];

        res = this.ProcessDealDataForPile("Stock", deck, script, cardIndex);
        deck = res.deck; script = res.script; cardIndex = res.cardIndex;
        res = this.ProcessDealDataForPile("Waste", deck, script, cardIndex);
        deck = res.deck; script = res.script; cardIndex = res.cardIndex;
        for (i = 3; i >= 0; i--)
        {
            res = this.ProcessDealDataForPile("Foundation" + i, deck, script, cardIndex);
            deck = res.deck; script = res.script; cardIndex = res.cardIndex;
        }
        for (i = 6; i >= 0; i--)
        {

            res = this.ProcessDealDataForPile("Tableau" + i, deck, script, cardIndex);
            deck = res.deck; script = res.script; cardIndex = res.cardIndex;
            res = this.ProcessDealDataForPile("FaceDown" + i, deck, script, cardIndex);
            deck = res.deck; script = res.script; cardIndex = res.cardIndex;
        }

        script = "BEGIN " + script + "END";
        return new DealData(Pile.ConstructSeedFromDeck(deck, this.CardSupply.Count).ToString(), script);
    };

    /// <summary>
    /// opt in ads for extra deals
    /// </summary>
    /// <param name="dealsCnt"></param>
    /// <param name="logAction"> </param>
    KlondikeAuthority.prototype.AddExtraDeals = function (dealsCnt, logAction)
    {
        //do nothing for Klondike
    };

    KlondikeAuthority.prototype.AddWildCard = function (logAction)
    {
        //no wild cards for klondike
    };

    KlondikeAuthority.prototype.ApplyCurrentOptInAdBonus = function (bonusType)
    {
        //no bonuses for klondike
    };

    KlondikeAuthority.prototype.ProcessDealDataForPile = function (pileName, deck, script, currentIndex)
    {
        var currentPile = this.CardSupply.GetPile(pileName);

        if (currentPile != null && !currentPile.Empty)
        {
            _.forEach (currentPile.GetCards(), function (card)
            {
                deck[currentIndex++] = card.Sequence;
            });
            script = "MOVE Root " + pileName + " " + currentPile.Count + " " + script;
        }

        return {deck: deck, script: script, currentIndex: currentIndex};
    };

    KlondikeAuthority.prototype.ForceDealScript = function (script)
    {
        this.DealScript = (script != null ? script : KlondikeAuthority.DefaultDealScript);
    };

    KlondikeAuthority.DefaultDealScript =
        "BEGIN " +
        "MOVE Root Stock 52 " +

        "MOVE Stock Tableau0 1 " +
        "MOVE Stock FaceDown1 1 " +
        "MOVE Stock FaceDown2 1 " +
        "MOVE Stock FaceDown3 1 " +
        "MOVE Stock FaceDown4 1 " +
        "MOVE Stock FaceDown5 1 " +
        "MOVE Stock FaceDown6 1 " +

        "MOVE Stock Tableau1 1 " +
        "MOVE Stock FaceDown2 1 " +
        "MOVE Stock FaceDown3 1 " +
        "MOVE Stock FaceDown4 1 " +
        "MOVE Stock FaceDown5 1 " +
        "MOVE Stock FaceDown6 1 " +

        "MOVE Stock Tableau2 1 " +
        "MOVE Stock FaceDown3 1 " +
        "MOVE Stock FaceDown4 1 " +
        "MOVE Stock FaceDown5 1 " +
        "MOVE Stock FaceDown6 1 " +

        "MOVE Stock Tableau3 1 " +
        "MOVE Stock FaceDown4 1 " +
        "MOVE Stock FaceDown5 1 " +
        "MOVE Stock FaceDown6 1 " +

        "MOVE Stock Tableau4 1 " +
        "MOVE Stock FaceDown5 1 " +
        "MOVE Stock FaceDown6 1 " +

        "MOVE Stock Tableau5 1 " +
        "MOVE Stock FaceDown6 1 " +

        "MOVE Stock Tableau6 1 " +

        "END";

    return KlondikeAuthority;
});

